import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service'; // Import AuthService to get the token
import * as CryptoJS from 'crypto-js';
import { EncryptionService } from '../encryption.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,private encryptionService: EncryptionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the authentication token from the AuthService
    const authToken = this.authService.authToken;
    let modifiedReq = req;

    // Check if the request body is FormData (i.e., file upload request)
    if (req.body instanceof FormData) {
      // When FormData is present, we do NOT modify the Content-Type header, it will be handled automatically.
      // We only add the Authorization header here
      
      modifiedReq = req.clone({
        responseType: 'text' as 'json',
        setHeaders: {
          'Authorization': `Bearer ${authToken}`,
           'Content-Type': 'multipart/form-data'
        }
      });
    } else {
      // For non-FormData requests (like JSON), we can safely add custom headers
      if (authToken) {
        if (req.method === 'GET' || req.method === 'DELETE') {
          const url = new URL(req.urlWithParams);
        const params: any = {};

        url.searchParams.forEach((value, key) => {
          params[key] = value;
        });

        const encrypted = this.encryptionService.encryptAES(JSON.stringify(params));

        const newUrl = req.url.split('?')[0]; // remove existing query
        modifiedReq = req.clone({
          url: newUrl,
          setParams: { data: encrypted }, 
          responseType: 'text' as 'json',
          setHeaders: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'text/plain',  
          }
        });
        }
        if ((req.method === 'POST' || req.method === 'PUT') && req.body) {
         const jsonString = JSON.stringify(req.body);
      const encryptedPayload = this.encryptionService.encryptAES(jsonString);
        modifiedReq = req.clone({
          body: encryptedPayload,
          responseType: 'text' as 'json',
          setHeaders: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'text/plain',  
          }
        });
        }
        
      }else{
         const jsonString = JSON.stringify(req.body);
      const encryptedPayload = this.encryptionService.encryptAES(jsonString);
        modifiedReq = req.clone({
          body: encryptedPayload,
          responseType: 'text' as 'json'
        });
      }
    }

    // Proceed with the modified request
   // return next.handle(modifiedReq);
  //    const modifiedReqe = req.clone({
  //   responseType: 'text' as 'json'
  // });
    return next.handle(modifiedReq).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && typeof event.body === 'string') {
        try {
          const decrypted = this.encryptionService.decryptAES(event.body);
          const parsed = JSON.parse(decrypted);
          return event.clone({ body: parsed });
        } catch (err) {
          console.error('Decryption failed:', err);
        }
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (typeof error.error === 'string') {
        try {
          const decrypted = this.encryptionService.decryptAES(error.error);
          const parsed = JSON.parse(decrypted);
          return throwError(() => new HttpErrorResponse({
            error: parsed,
            headers: error.headers,
            status: error.status,
            statusText: error.statusText,
            url: error.url || undefined
          }));
        } catch {
          try {
            const parsed = JSON.parse(error.error);
            return throwError(() => new HttpErrorResponse({
              error: parsed,
              headers: error.headers,
              status: error.status,
              statusText: error.statusText,
              url: error.url || undefined
            }));
          } catch {
            return throwError(() => error);
          }
        }
      }
      return throwError(() => error);
    })
  );
  }


}
